import React, { useEffect, useState } from 'react';
export function StickyNav() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const hero = document.getElementById('hero');
    if (!hero) return;
    const observer = new IntersectionObserver(([entry]) => {
      setIsVisible(!entry.isIntersecting);
    }, {
      threshold: 0.1
    });
    observer.observe(hero);
    return () => observer.disconnect();
  }, []);
  if (!isVisible) return null;
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-primary/95 backdrop-blur-md border-b border-white/10 py-3.5 animate-in slide-in-from-top-full duration-300" data-id="element-42">
      <div className="max-w-[1100px] mx-auto px-6" data-id="element-43">
        <div className="flex flex-wrap justify-between items-center gap-4 md:justify-between justify-center" data-id="element-44">
          <span className="font-playfair text-base font-black text-accent" data-id="element-45">
            SOS Reflujo 11 PM
          </span>
          <span className="text-text-muted text-sm hidden md:inline-flex items-center gap-2" data-id="element-46">
            <span className="price-struck text-sm font-semibold" data-id="element-47">120 USD</span>
            <strong className="text-accent text-lg font-black" data-id="element-48">
              Hoy 12 USD
            </strong>
          </span>
          <a href="#cta-final" className="btn-sweep bg-gradient-to-r from-accent via-accent-light to-accent-dark bg-[length:300%_100%] animate-btn-gradient text-primary text-sm font-extrabold py-2.5 px-6 rounded-md no-underline whitespace-nowrap transition-transform hover:scale-105" data-id="element-49">
            Quiero acceso ahora
          </a>
        </div>
      </div>
    </nav>;
}